import { render, staticRenderFns } from "./MessageExchange.vue?vue&type=template&id=6bb8c200"
import script from "./MessageExchange.vue?vue&type=script&lang=js"
export * from "./MessageExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb8c200')) {
      api.createRecord('6bb8c200', component.options)
    } else {
      api.reload('6bb8c200', component.options)
    }
    module.hot.accept("./MessageExchange.vue?vue&type=template&id=6bb8c200", function () {
      api.rerender('6bb8c200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MessageExchange.vue"
export default component.exports